module.exports = __webpack_public_path__ + "static/media/roulette.d54e3c4c.png";